import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "components/app/dialog/dialog";

import { DialogDescription } from "components/ui/dialog";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";

import { Loader, X } from "lucide-react";

import { useState } from "react";

interface DialogProps {
  isDailogAddRemark: boolean;
  setisDailogAddRemark: (value: boolean) => void;
  status: any;
  employeeInitRequest: any;
  setOpenPopoverIndex: any;
  submitShopEmployeeRequestUpdateStatus: any;
  submitShopEmployeeRequestUpdateStatusLoading: any;
}
export default function DailogAddRemark({
  submitShopEmployeeRequestUpdateStatus,
  isDailogAddRemark,

  setisDailogAddRemark,
  status,
  employeeInitRequest,
  submitShopEmployeeRequestUpdateStatusLoading,
}: DialogProps) {
  const [formData, setFormData] = useState({
    remark: "",
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: string) => {
    setFormData((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleSubmit = () => {
    submitShopEmployeeRequestUpdateStatus(employeeInitRequest?.id, status, formData.remark).then((res: any) => {
      setisDailogAddRemark(false);
    });
  };

  return (
    <Dialog open={isDailogAddRemark}>
      <DialogContent isShowBtnXClose={false} className="custom-dialog-class flex flex-col justify-between">
        <DialogHeader>
          <DialogTitle>
            {status === "Cancelled" ? "Cancel Request" : status === "Rejected" ? "Rejected Request" : status === "Approved" ? "Approved Request" : "Resubmit Request"}
          </DialogTitle>
          <DialogDescription>
            {status === "Cancelled"
              ? `Input your remark, click "Cancel" button to cancel request.`
              : status === "Rejected"
              ? `Input your remark, click "Reject" button to reject request.`
              : status === "Approved"
              ? `Input your remark, click "Accept" button to accept request.`
              : `Input your remark, click "Resubmit" button to resubmit request.`}
          </DialogDescription>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => {
              setisDailogAddRemark(false);
            }}
          >
            <X />
          </div>
        </DialogHeader>
        <ScrollArea className="mt-2 w-full gap-3">
          <div className="flex flex-col py-[10px]">
            <div className="sticky top-0 left-0 bg-white dark:bg-[#020817] px-1">
              <label htmlFor="remark" className="block mb-1 text-sm font-medium">
                Remark
              </label>
              <div className="mt-2">
                <textarea
                  className="text-[15px] border border-gray-200 rounded-md focus:border-blue-600 outline-none w-full px-5 py-3 bg-transparent"
                  value={formData.remark}
                  onChange={(e) => handleChange(e, "remark")}
                  rows={8}
                />
              </div>
            </div>
          </div>
          <ScrollBar orientation="vertical" />
        </ScrollArea>
        <DialogFooter>
          <div className="flex justify-between gap-3 items-center  left-0 w-full mx-0 ">
            {employeeInitRequest?.status === "Pending" &&
              (employeeInitRequest?.allow_cancel === "Yes" ? (
                <>
                  <button
                    onClick={() => {
                      handleSubmit();
                    }}
                    className="w-full outline-none focus:border-none  flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg"
                  >
                    {submitShopEmployeeRequestUpdateStatusLoading ? <Loader className="animate-spin" /> : "Cancel"}
                  </button>
                </>
              ) : employeeInitRequest?.allow_accept === "Yes" ? (
                <>
                  <button
                    onClick={() => {
                      handleSubmit();
                    }}
                    className="w-full outline-none focus:border-none  flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg"
                  >
                    {submitShopEmployeeRequestUpdateStatusLoading ? <Loader className="animate-spin" /> : "Reject"}
                  </button>
                  <button
                    onClick={() => {
                      handleSubmit();
                    }}
                    className="w-full outline-none focus:border-none  flex items-center justify-center bg-green-500 text-white text-lg py-2 rounded-lg"
                  >
                    {submitShopEmployeeRequestUpdateStatusLoading ? <Loader className="animate-spin" /> : "Approve"}
                  </button>
                </>
              ) : null)}

            {employeeInitRequest?.status === "Reject" && employeeInitRequest?.allow_cancel === "Yes" && (
              <button
                onClick={() => {
                  handleSubmit();
                }}
                className="w-full outline-none focus:border-none  flex items-center justify-center bg-yellow-500 text-white text-lg py-2 rounded-lg"
              >
                {submitShopEmployeeRequestUpdateStatusLoading ? <Loader className="animate-spin" /> : "Resubmit"}
              </button>
            )}

            {employeeInitRequest?.status === "Approved" && employeeInitRequest?.allow_cancel === "Yes" && (
              <button
                onClick={() => {
                  handleSubmit();
                }}
                className="w-full  outline-none focus:border-none  flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg"
              >
                {submitShopEmployeeRequestUpdateStatusLoading ? <Loader className="animate-spin" /> : "Cancel"}
              </button>
            )}
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
